export const PRIVACY_URL = 'https://ec.sod.co.jp/prime/help/rules.php';
export const TERMS_SERVICE_URL = 'https://help.h2u.jp/terms/service';
export const TERMS_ACCOUNT_URL = 'https://help.h2u.jp/terms/account';
export const COMPANY_URL = 'https://corporate.sod.co.jp/';
